import clsx from "clsx";
import type { JSX } from "react";
type Props = Readonly<{
  message?: string;
  className?: string;
}>;

export const InputError = ({ message, className = "" }: Readonly<Props>): JSX.Element => {
  if (!message) {
    return <></>;
  }

  return (
    <div className="mt-0.5 flex justify-end text-feedback-error lg:relative lg:mt-0 z-20">
      <span className={`bottom-[-.25rem] right-0 text-end lg:absolute lg:translate-y-full ${className}`}>
        {message}
      </span>
    </div>
  );
};
